import PrepareSelfie from "@/modules/selfie/pages/PrepareSelfie.vue";
import CaptureSelfie from "@/modules/selfie/pages/CaptureSelfie.vue";
import FallbackSelfie from "@/modules/selfie/pages/FallbackSelfie.vue";

export default [
  {
    path: "/selfie",
    name: "prepareSelfie",
    component: PrepareSelfie,
  },
  {
    path: "/selfie/capture",
    name: "captureSelfie",
    component: CaptureSelfie,
  },

  {
    path: "/selfie/fallback",
    name: "fallbackSelfie",
    component: FallbackSelfie,
  },
];
